import { Injectable } from '@angular/core'
import { doc, Firestore, getDoc } from '@angular/fire/firestore'
import { Functions, httpsCallable } from '@angular/fire/functions'
import { MatSnackBar } from '@angular/material/snack-bar'
import { DocumentEntryItem } from 'src/app/components/documents/documents.component'
import { Dog } from 'src/domain/dog'

@Injectable({ providedIn: 'root' })
export class IdCardEmailService {
  constructor(private functions: Functions, private storage: Firestore, private snack: MatSnackBar) {}

  canSendEmail(document: DocumentEntryItem): boolean {
    return !!document.idCard?.clientPhotoUrl
  }

  async sendPrintSheetEmail(dogId: string, document: DocumentEntryItem): Promise<boolean> {
    if (!this.canSendEmail(document)) {
      return false
    }

    const dogDoc = await getDoc(doc(this.storage, 'dogs', dogId))
    const ownerEmail = (dogDoc.data() as Dog)?.owner?.email

    if (!ownerEmail) {
      this.snack.open('A gazdinak nincs email címe megadva', 'Ajaj')
      return false
    }

    const confirmed = confirm(`Biztosan emailben elküldi az igazolványt (${document.idCard!.idNumber}) a következő címre: ${ownerEmail}?`)
    if (!confirmed) {
      return false
    }

    try {
      const sendEmail = httpsCallable(this.functions, 'sendIdCardPrintEmail')
      await sendEmail({ dogId, docId: document.docId })
      this.snack.open('Igazolvány elküldve emailben', 'Ok', { duration: 3000 })
      return true
    } catch (e) {
      console.error(e)
      this.snack.open('Nem sikerült elküldeni az igazolványt emailben', 'Ajaj')
      return false
    }
  }
}
